import BaseService from './BaseService';
import * as apiroutes from '../apiRoutes';

class ModifierOptionService extends BaseService {
    constructor() {
        super(apiroutes.MODIFIER_OPTION);
    }

    async create(data) {
        return await super.customCall('POST', '', data, null, 'json');
    }

    async update(id, data) {
        return await super.customCall('PATCH', `/${id}`, data, null, 'json');
    }

    async updateStatus(id, data) {
        return await super.customCall('PUT', `/status/${id}`, data, null, 'json');
    }

    async delete(id) {
        return await super.delete(id);
    }

    async getAll(params = {}) {
        return await super.customCall('GET', '', null, params, null);
    }

    async getById(id) {
        return await super.getById(id);
    }

    async search(searchTerm, filters = {}) {
        return await super.search(searchTerm, filters);
    }
}
const ModifierOptionServices = new ModifierOptionService();

export default ModifierOptionServices;